// The backend's metadata.reason when a customer already has a project at the address
// (backend#493). It comes with the existing project's projectId and projectNumber.
export const PROJECT_ADDRESS_TAKEN = 'projectAddressTaken';

/** What the user is told about a customer's project at the same address (#532). */
export const projectAddressTakenMessage = (projectNumber?: string | null): string =>
  projectNumber
    ? `Kunden har redan ett projekt på den här adressen (${projectNumber}).`
    : 'Kunden har redan ett projekt på den här adressen.';
